import { apiV2 } from "./sdApi";

export * from "./entity";

export const centerApi = {
    apiV2: apiV2,
};